import React, { useState } from "react";
import { Typography, Stack, Box, Tab } from "@mui/material";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
//Srcs
import "../Style/pagestyle.scss";
import AjustmentInPage from "../Components/Ajustment/AdjustIn/AjustmentInPage";
import AdjustOutPage from "../Components/Ajustment/AdjustOut/AdjustOutPage";

export default function Ajustment() {
  const [getAdjDate, setGetAdjDate] = useState();
  //tab
  // const [value, setValue] = useState(() => {
  //   const tabAjustmentFormLocal = window.localStorage.getItem("tabAjustmentFormLocal");
  //   return tabAjustmentFormLocal ? JSON.parse(tabAjustmentFormLocal) : "onhand";
  // });
  // const handleChange = (event, newValue) => {
  //   setValue(newValue);
  //   window.localStorage.setItem("tabAjustmentFormLocal", JSON.stringify(newValue));
  // };

  const tabAjustmentFormLocal = JSON.parse(
    window.localStorage.getItem("tabAjustmentFormLocal")
  );
  const [value, setValue] = useState(
    tabAjustmentFormLocal ? tabAjustmentFormLocal : "adjustin"
  );
  const handleChange = (event, newValue) => {
    setValue(newValue);
    window.localStorage.setItem(
      "tabAjustmentFormLocal",
      JSON.stringify(newValue)
    );
    // window.localStorage.setItem("tabAjustmentFormLocal", JSON.stringify(newValue));
  };
  return (
    <div className="page-container">
      <Stack direction="row" spacing={2} className="page-header">
        <Stack direction="column" justifyContent="center">
          <Box className="slash" />
        </Stack>
        <Stack direction="column" justifyContent="center">
          {/* <Link className="page-link-title" to="/setting"> */}
          <Typography className="page-title">ការកែប្រែ</Typography>
          {/* </Link> */}
        </Stack>
      </Stack>
      <Stack direction="row" justifyContent="center">
        <Box sx={{ width: "100%" }}>
          <TabContext value={value}>
            <Box className="tab-val">
              <TabList onChange={handleChange}>
                <Tab
                  className={
                    value === "adjustin" ? "active-tab" : "nonactive-tab"
                  }
                  label="ផ្ទេរចូល"
                  value="adjustin"
                />
                <Tab
                  className={
                    value === "adjustout" ? "active-tab" : "nonactive-tab"
                  }
                  label="ផ្ទេរចេញ"
                  value="adjustout"
                />
              </TabList>
            </Box>
          </TabContext>
        </Box>
      </Stack>
      <Box sx={{ flexGrow: 1 }} />
      <Box sx={{ width: "100%" }}>
        <TabContext value={value}>
          <TabPanel value="adjustin">
            <AjustmentInPage />
          </TabPanel>
          <TabPanel value="adjustout">
            <AdjustOutPage />
          </TabPanel>
        </TabContext>
      </Box>
    </div>
  );
}
